<script setup lang="ts">
import { defineEmits } from 'vue';
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import ComErrorIds from '@/modules/commissioning/components/ComErrorIds.vue';

defineProps<{
  title?: string;
  subtitle?: string;
  terminals: string[];
  actionButtonText?: string;
  failIds: string[];
  contactButtonText?: string;
  noteText?: string;
}>();

const emit = defineEmits<{
  (e: 'action-click'): void;
  (e: 'contact-support-click'): void;
}>();

const onActionButtonClick = () => {
  emit('action-click');
};

const onContactSupportClick = () => {
  emit('contact-support-click');
};
</script>

<template>
  <div class="error-summary-card">
    <div class="error-summary-card-header">
      <h4 v-if="title" class="error-summary-card-title">{{ title }}</h4>
      <p v-if="subtitle" class="error-summary-card-subtitle">
        {{ subtitle }}
      </p>
      <div v-if="failIds.length > 0" class="error-summary-card-fail-ids">
        <ComErrorIds :failIds="failIds" />
      </div>
      <div v-if="terminals.length > 0" class="error-summary-card-terminals">
        <ul>
          <li v-for="terminal in terminals" :key="terminal">
            {{ terminal }}
          </li>
        </ul>
      </div>
    </div>

    <div v-if="noteText" class="error-summary-card-note">
      <p>{{ noteText }}</p>
    </div>

    <div v-if="actionButtonText" class="error-summary-card-content">
      <ButtonPrimary
        block
        class="error-cta-button"
        data-tn="error-summary-card-action-button"
        @click="onActionButtonClick"
      >
        {{ actionButtonText }}
      </ButtonPrimary>
    </div>
    <div v-if="contactButtonText" class="error-summary-card-content">
      <ButtonPrimary
        block
        class="error-cta-button"
        data-tn="error-summary-card-contact-support-button"
        @click="onContactSupportClick"
      >
        {{ contactButtonText }}
      </ButtonPrimary>
    </div>
  </div>
</template>

<style scoped lang="less">
.error-summary-card {
  background-color: @color-background-light;
  padding: 16px;
  border-radius: 8px;

  .error-summary-card-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    .error-summary-card-title {
      font-size: 16px;
      font-weight: 500;
      color: @color-primary;
      margin-bottom: 0;
    }

    .error-summary-card-subtitle {
      margin: 0;
    }

    .error-summary-card-terminals {
      margin: 0.5rem 0;
      ul {
        padding: 0;
        margin: 0;
      }
    }

    .error-summary-card-fail-ids {
      margin: 0.5rem 0;
    }
  }

  .error-summary-card-note {
    text-align: center;
    margin: 1rem 0;
  }

  .error-cta-button {
    margin-top: 0.5rem;
  }
}
</style>
